import { SVGProps } from "react";

const Logout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.90039 8.14982C9.21039 4.61527 11.0604 3.172 15.1104 3.172H15.2404C19.7104 3.172 21.5004 4.92945 21.5004 9.31818V15.7196C21.5004 20.1084 19.7104 21.8658 15.2404 21.8658H15.1104C11.0904 21.8658 9.24039 20.4422 8.91039 16.9665"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0001 12.5091H3.62012"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.85 9.21999L2.5 12.5091L5.85 15.7982"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Logout;
